/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Label_TextInputs */

const en_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const ar_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأسئلة الشائعة`)
};

const de_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const es_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas frecuentes`)
};

const fr_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const it_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const ja_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある質問`)
};

const ko_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자주 묻는 질문`)
};

const pt_br_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perguntas frequentes`)
};

const ru_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вопросы и ответы`)
};

const th_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คำถามที่พบบ่อย`)
};

const tr_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSS`)
};

const zh_cn_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

const zh_tw_faq_label_text = /** @type {(inputs: Faq_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常見問題`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Faq_Label_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const faq_label_text = /** @type {((inputs?: Faq_Label_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Label_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_label_text(inputs)
	if (locale === "ar") return ar_faq_label_text(inputs)
	if (locale === "de") return de_faq_label_text(inputs)
	if (locale === "es") return es_faq_label_text(inputs)
	if (locale === "fr") return fr_faq_label_text(inputs)
	if (locale === "it") return it_faq_label_text(inputs)
	if (locale === "ja") return ja_faq_label_text(inputs)
	if (locale === "ko") return ko_faq_label_text(inputs)
	if (locale === "pt_br") return pt_br_faq_label_text(inputs)
	if (locale === "ru") return ru_faq_label_text(inputs)
	if (locale === "th") return th_faq_label_text(inputs)
	if (locale === "tr") return tr_faq_label_text(inputs)
	if (locale === "zh_cn") return zh_cn_faq_label_text(inputs)
	return zh_tw_faq_label_text(inputs)
});